import { getStream } from '../base/selectors';
function getOffsetStream(state, streamId) {
    return getStream(state, streamId);
}
export var getNextOffset = function (state, streamId) {
    var stream = getOffsetStream(state, streamId);
    var nextOffset = stream.nextOffset, items = stream.items;
    return nextOffset !== undefined && nextOffset !== null
        ? nextOffset
        : (items && items.length) || 0;
};
export var getPrevOffset = function (state, streamId) {
    return getOffsetStream(state, streamId).prevOffset || 0;
};
//# sourceMappingURL=selectors.js.map